<template>
    <el-container id='root-container'>
        <el-aside class="aside-container" style="width: 200px;">
            <left-nav/>
        </el-aside>
        <el-container class="left-container">
            <el-header>
                <top-bar/>
            </el-header>
            <el-main  class="main-container">
                <right-tabs  class="main-content"/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import LeftNav from "./parts/LeftNav";
import RightTabs from "./parts/main/RightTabs";
import TopBar from "./parts/TopBar";
export default {
  components: {
    LeftNav,
    RightTabs,
    TopBar
  }
};
</script>

<style  lang="scss" scoped>
.aside-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    // background: #3490EE;
    background: #3B3A54;
}
.left-container {
    margin-left: 200px;
    -ms-overflow-x:hidden;
}
.el-header {
    box-shadow: 0px -2px 2px 0px #e5e5e5 inset;
    // background:#3490EE;
    background: #fff;
} 
.main-container {
  position: relative;
  overflow: hidden;
  background: #f1f1f1;
  padding-bottom: 0;
  .main-content {
      padding: 20px;
      min-height: calc(100vh - 120px); 
      background: #fff;
  }
}
</style>